import { makeStyles } from '@material-ui/core/styles';

const EventSummaryStyles =
    makeStyles((theme) => ({
        eventSummaryContainer: {
            display: "flex",
            backgroundColor: theme.palette.primary.darkest,//"#eee !important",
            color: theme.palette.text.primary,
            //padding: "50px",

            [theme.breakpoints.up("sm")]: {
                height: "280px",
            },
            [theme.breakpoints.down("xs")]: {
                flexDirection: "column",
            },

        },
        eventSummaryTitleMargin: {
            marginBottom: "30px",
        },
        eventSummaryTitleStyle: {
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
        },
        eventSummaryLinkMargin: {
            marginTop: "30px",
        },
        eventSummarySection: {
            width: "50%",
            padding: "20px",
            [theme.breakpoints.down("md")]: {
                order: "2",
                width: "100%",
                marginTop: "8px",
            },
        },
        eventSummarySectionNoImg: {
            width: "100%",
            padding: "40px",
        },
        eventSummaryImgSection: {
            display: "flex",
            width: "50%",

            [theme.breakpoints.up("md")]: {
                maxHeight: "280px",
            },
            [theme.breakpoints.down("md")]: {
                order: "1",
                width: "100%",
                textAlign: "center",
            },
        },
        eventSummaryImgContainer: {
            verticalAlign: "middle",
            margin: "auto",
        },
        eventInfo: {
            padding: "10px 0px",
        }
    }));

export default EventSummaryStyles;